import type { IUsageFeeBill } from '../../types';

import { sortByCondition } from '~/utils';

export function sortByCycleStartDate(bills?: IUsageFeeBill[]): IUsageFeeBill[] | undefined {
  if (!bills) return;

  return sortByCondition<IUsageFeeBill>(bills, {
    attr: 'cycleStartDate',
    order: 'desc',
  });
}
